import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Client } from './client';
import type { Address } from './address';

export class Site extends BaseClass implements BaseRepository {
  name: string;
  clients: Client[];
  otherSite: boolean;
  documentUrl: string;
  siren: string;
  allowOtherAddress: boolean | null;
  transmissionOnly: boolean;
  address?: Address;
  addressId?: string;

  constructor();
  constructor(
    name: string,
    clients: Client[],
    otherSite: boolean,
    documentUrl?: string,
    siren?: string,
    allowOtherAddress?: boolean,
    transmissionOnly?: boolean,
  );
  constructor(
    name?: string,
    clients?: Client[],
    otherSite?: boolean,
    documentUrl?: string,
    siren?: string,
    allowOtherAddress?: boolean,
    transmissionOnly?: boolean,
  ) {
    super();

    this.name = this.trim(name);
    this.clients = clients || [];
    this.otherSite = otherSite;
    this.documentUrl = documentUrl;
    this.siren = siren;
    this.allowOtherAddress = allowOtherAddress;
    this.transmissionOnly = transmissionOnly;
  }

  static fromObject(object: Site): Site {
    return Object.assign(new Site(), {
      ...object,
      clients: object.clients ? object.clients.map(c => Client.fromObject(c)) : [],
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
